// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/magnifying-glass.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/magnifying-glass'

import { Icon, type IconComponentProps } from '../icon'

export const MagnifyingGlassIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
